import { render, staticRenderFns } from "./Bind.vue?vue&type=template&id=7a31cdb2&scoped=true"
import script from "./Bind.vue?vue&type=script&lang=js"
export * from "./Bind.vue?vue&type=script&lang=js"
import style0 from "./Bind.vue?vue&type=style&index=0&id=7a31cdb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a31cdb2",
  null
  
)

export default component.exports